<template>
  <div class="tag-input">
    <div
      v-for="(tag, index) in tags"
      :key="tag"
      class="tag-input__tag"
    >
      <span @click="removeTag(index)">x</span>
      {{ tag }}
    </div>
    <input
      v-model="input"
      type="text"
      class="tag-input__text"
      :placeholder="placeholder"
      @keydown.delete="removeLastTag"
    >
  </div>
</template>
<script>
export default {
  props: {
    tags: {
      type: Array,
      required: true
    },
    tagMaxSize: {
      type: Number,
      required: true
    },
    tagMaxNumber: {
      type: Number,
      required: true
    },
    placeholder: {
      type: String,
      default: undefined
    },
  },
  emits: ['update:modelValue','new-tag'],
  data () {
    return {
      input: ''
    }
  },
  watch: {
    input: function (val) {
      let tags = this.resetIfNull(this.tags)
      if (val.length === this.tagMaxSize) {
        if (tags.length <= this.tagMaxNumber && !tags.includes(val)) {
          tags.push(val)
          this.$emit('new-tag', tags)
        }
        this.input = ''
      }
    },
  },
  methods: {
    removeTag (index) {
      let tags = this.resetIfNull(this.tags)
      tags.splice(index, 1)
      this.$emit('new-tag', tags)
      // this.$emit('update:modelValue', this.tags)
    },
    removeLastTag (event) {
      if (event.target.value.length === 0) {
        this.removeTag(this.tags.length - 1)
      }
    },
    resetIfNull (tags) {
      if (!tags) {
        tags = []
        return tags
      }
      else {
        return tags
      }
    }
  }
}
</script>
<style scoped>
  .tag-input {
    width: 100%;
    border: 1px solid #eee;
    font-size: 0.9em;
    height: 50px;
    box-sizing: border-box;
    padding: 0 10px;
  }

  .tag-input__tag {
    height: 30px;
    float: left;
    margin-right: 10px;
    background-color: #eee;
    margin-top: 10px;
    line-height: 30px;
    padding: 0 5px;
    border-radius: 5px;
  }

  .tag-input__tag > span {
    cursor: pointer;
    opacity: 0.75;
  }

  .tag-input__text {
    border: none;
    outline: none;
    font-size: 0.9em;
    line-height: 50px;
    background: none;
  }
</style>
